import { type RefObject, useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

import type { ArticleReference } from 'app/modules/wallforming/components/scenes/objects/articles/types/articleReference';

interface DraggingLifecycleHandlerProps {
    articleId: string;
    isMainCanvas: boolean;
    articleRef: RefObject<ArticleReference>;
}

/**
 * Registers and unregisters drag references for an article during its lifecycle.
 */
export const useDraggingLifecycleHandler = ({
    articleId,
    isMainCanvas,
    articleRef
}: DraggingLifecycleHandlerProps) => {
    const { registerArticleDragReference, unregisterArticleDragReference } = usePlacementStore(
        useShallow((state) => ({
            registerArticleDragReference: state.registerArticleDragReference,
            unregisterArticleDragReference: state.unregisterArticleDragReference
        }))
    );

    useEffect(() => {
        if (!isMainCanvas) {
            return;
        }

        registerArticleDragReference(articleId, articleRef);

        return () => {
            unregisterArticleDragReference(articleId);
        };
    }, [articleId, isMainCanvas, articleRef, registerArticleDragReference, unregisterArticleDragReference]);
};
